var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"mb-2"},[_c('b-col',{staticClass:"text-right"})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }